import React from 'react';
import LazyLoad from 'react-lazyload';
import { __ } from '../../../../utils/translation-service';
import { IFooter, IImageLink, ISocialMediaIcon } from '@interfaces';

const styles = {
    visuallyHidden: {
        border: '0',
        clip: 'rect(1px 1px 1px 1px)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        width: '1px',
    },
};

export class FooterPayment extends React.Component<{ list: IImageLink[] }, {}> {
    public render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((item, key) => (
                    <div key={key} className="pull-left">
                        <LazyLoad once={true} offset={50}>
                            <img src={item.image} alt={item.altText} title={item.title} />
                        </LazyLoad>
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterBestPrice extends React.Component<{ list: IImageLink[] }, {}> {
    public render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((item, key) => (
                    <div key={key} className="pull-left">
                        <img src={item.image} alt={item.altText} title={item.title} />
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterSaferShopping extends React.Component<{ list: IImageLink[] | undefined }, {}> {
    public render() {
        return (
            this.props.list && (
                <div className="footer_icons_items">
                    {this.props.list.map((item, key) => (
                        <div key={key} className="pull-left">
                            <img src={item.image} alt={item.altText} title={item.title} />
                        </div>
                    ))}
                </div>
            )
        );
    }
}

export class FooterSocialMediaIcons extends React.Component<{ list: ISocialMediaIcon[] }, {}> {
    public render() {
        return (
            <div className="footer_icons_items">
                {this.props.list.map((socialMedia, key) => (
                    <div key={key} className="pull-left">
                        <a
                            className={`icon-${socialMedia.social_icon}`}
                            href={socialMedia.targetUrl}
                            title={socialMedia.linkTitle}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="tha"
                        >
                            <span style={styles.visuallyHidden}> </span>
                        </a>
                    </div>
                ))}
            </div>
        );
    }
}

export class FooterIcons extends React.Component<
    {
        socialMediaIcons: IFooter['socialMediaIcons'];
        awards: IFooter['awards'];
        security: IFooter['security'];
        paymentMethods: IFooter['paymentMethods'];
    },
    {}
> {
    public render() {
        return (
            <div className="footer_icons">
                {this.props.socialMediaIcons.length > 0 ? (
                    <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_icons_social">
                        <strong className="text-uppercase">{__('socialMedia')}</strong>
                        <div className="footer_icons_items">
                            <FooterSocialMediaIcons list={this.props.socialMediaIcons} />
                        </div>
                    </div>
                ) : null}

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">{__('paymentMethods')}</strong>
                    <div className="footer_icons_items">
                        {this.props.paymentMethods ? (
                            <FooterPayment list={this.props.paymentMethods} />
                        ) : null}
                    </div>
                </div>

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">{__('bestPriceGuarantee')}</strong>
                    <div className="footer_icons_items">
                        {this.props.awards ? <FooterBestPrice list={this.props.awards} /> : null}
                    </div>
                </div>

                <div className="col-xs-12 col-is-6 col-sm-4 col-md-3 footer_images">
                    <strong className="text-uppercase">{__('safeShopping')}</strong>
                    <div className="footer_icons_items">
                        {this.props.awards ? (
                            <FooterSaferShopping list={this.props.security} />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
